import isObject from './is-object';

const getPropValues = (propertiesToDisplay, props) =>
  propertiesToDisplay
    .map(property => {
      const [filteredProperty, subtype] = property.split('.');
      const value = props[filteredProperty];

      if (Array.isArray(value)) {
        return value.map(prop => (subtype ? prop[subtype] : prop));
      }

      if (isObject(value)) {
        return value[subtype];
      }

      return value;
    })
    .filter(Boolean);

export default getPropValues;
